import * as React from 'react';
const SvgChevronArrow = (props) => (
  <svg viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m1.516 1.272 5.657 5.657-5.657 5.657" stroke="#CE9200" strokeWidth={2} />
  </svg>
);
export default SvgChevronArrow;
